import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMyResume } from '../../hooks/resume';
import { Button } from '../Button';
import { AnimationLayout } from './AnimationLayout';

function isDocumentComplete(resume: {
  personalId: string;
  healthImgUrl: string;
  identityDocUrl: string;
  agreementFileUrl: string;
}): boolean {
  const yy = parseInt(resume.personalId.slice(0, 2));
  const birthYear = (yy >= 40 ? 1900 : 2000) + yy;
  const mm = parseInt(resume.personalId.slice(2, 4));
  const dd = parseInt(resume.personalId.slice(4, 6));
  const isMinor = new Date() < new Date(birthYear + 18, mm - 1, dd);
  return (
    !!resume.healthImgUrl &&
    !!resume.identityDocUrl &&
    (!isMinor || !!resume.agreementFileUrl)
  );
}

export const DocumentReminderModal = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { data: resume } = useMyResume();

  useEffect(() => {
    if (!resume) return;
    if (pathname.startsWith('/mypage/resume')) return;

    const today = new Date().toISOString().split('T')[0];
    if (
      localStorage.getItem('docModalLastDate') !== today &&
      !isDocumentComplete(resume)
    ) {
      localStorage.setItem('docModalLastDate', today);
      setOpen(true);
    }
  }, [resume]);

  return (
    <AnimationLayout open={open} onClose={() => setOpen(false)}>
      <div className="my-8 w-full max-w-md transform space-y-3 overflow-hidden rounded-lg bg-white p-6 text-left shadow-xl transition-all">
        <h3 className="font-semibold">서류 제출 안내</h3>
        <p className="whitespace-pre-wrap font-medium text-gray-700">
          {`보건증, 주민등록등본(또는 외국인 증명서) 등\n필요 서류를 아직 제출하지 않으셨습니다.\n서류를 제출해야 알바 근무가 가능합니다.`}
        </p>
        <div className="space-y-3 pt-8">
          <Button
            text="서류 제출하러 가기"
            className="filled-brand-1 w-full"
            onClick={() => {
              setOpen(false);
              navigate('/mypage/resume');
            }}
          />
          <Button
            text="나중에 하기"
            className="outlined-gray-900 w-full border-gray-400"
            onClick={() => setOpen(false)}
          />
        </div>
      </div>
    </AnimationLayout>
  );
};
